exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n[data-v-4e764f17] .text .text{color:#ff0000 !important\n}\n", "", {"version":3,"sources":["/app/frontend/src/components/informacoesCadastro/InformacoesEndereco.vue","/app/frontend/src/components/informacoesCadastro/InformacoesEndereco.vue"],"names":[],"mappings":";AAAA,8BCgFE,wBAAyB;CAC1B","file":"InformacoesEndereco.vue","sourcesContent":[">>>.text .text{color:#ff0000 !important}\n","\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n>>> .text .text{\n  color: #ff0000 !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e764f17","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/informacoesCadastro/InformacoesEndereco.vue
// module id = C5Jp
// module chunks = 11